import { jsx } from 'react/jsx-runtime';
import { IconBase } from '../../icon-base/index.js';

const InfoBold = (props) => (jsx(IconBase, Object.assign({}, props, { svgContent: jsx("path", { className: "cls-1", d: "M10.80011,1.36129a9.43848,9.43848,0,1,0,9.43848,9.43848A9.43847,9.43847,0,0,0,10.80011,1.36129Zm0,16.877a7.43848,7.43848,0,1,1,7.43848-7.43848A7.43849,7.43849,0,0,1,10.80011,18.23825ZM11.625,7.45849H9.95V5.78344h1.675ZM9.95834,9.11663H11.65v6.69989H9.95834Z" }), iconName: "info-bold", viewBox: "0 0 21.6 21.6" })));
InfoBold.displayName = 'VDS_Icon';

export { InfoBold as default };
